import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ArcaLayout from './ArcaLayout';
import ArcaApresentacoesPage from './ArcaApresentacoesPage';
import ArcaModelosPage from './ArcaModelosPage';
import ArcaConfiguracoesPage from './ArcaConfiguracoesPage';
import ArcaFormulariosPage from './ArcaFormulariosPage';
import ArcaFormulariosConfigPage from './ArcaFormulariosConfigPage';
import ArcaEditaisPage from './ArcaEditaisPage';
import ArcaPdfPage from './ArcaPdfPage';
import ArcaPdfJuntarPage from './ArcaPdfJuntarPage';
import ArcaPdfDividirPage from './ArcaPdfDividirPage';
import ArcaPdfOrganizarPage from './ArcaPdfOrganizarPage';
import ArcaPdfComprimirPage from './ArcaPdfComprimirPage';
import ArcaPdfJpgParaPdfPage from './ArcaPdfJpgParaPdfPage';
import ArcaPdfWordParaPdfPage from './ArcaPdfWordParaPdfPage';
import ArcaPdfPdfParaJpgPage from './ArcaPdfPdfParaJpgPage';
import ArcaPdfPdfParaWordPage from './ArcaPdfPdfParaWordPage';
import ArcaPdfProcessoPagamentoPage from './ArcaPdfProcessoPagamentoPage';
import ArcaProcessoAdministrativoListPage from './processo-administrativo/ArcaProcessoAdministrativoListPage';
import ArcaProcessoAdministrativoDetalhePage from './processo-administrativo/ArcaProcessoAdministrativoDetalhePage';
import {
  ARCA_APRESENTACAO_HABILITADA,
  canAccessArcaProcessosContratos,
} from './utils/arcaAccess';

const ARCA_HOME = '/arca/pdf';

/** Mantém páginas de apresentação no bundle; redireciona enquanto desabilitada. */
function ApresentacaoGate({ children }) {
  if (!ARCA_APRESENTACAO_HABILITADA) {
    return <Navigate to={ARCA_HOME} replace />;
  }
  return children;
}

function ProcessosContratosGate({ children }) {
  const auth = useAuth();
  if (!canAccessArcaProcessosContratos(auth)) {
    return <Navigate to={ARCA_HOME} replace />;
  }
  return children;
}

/** Rotas internas do ecossistema ARCA (isolado do layout principal do SGC). */
export default function ArcaModule() {
  return (
    <Routes>
      <Route path="/arca" element={<ArcaLayout />}>
        <Route index element={<Navigate to={ARCA_HOME} replace />} />

        {/* Apresentação — código preservado; gate desabilita para todos */}
        <Route path="apresentacao" element={<ApresentacaoGate><Navigate to="/arca/apresentacao/workspace" replace /></ApresentacaoGate>} />
        <Route
          path="apresentacao/workspace"
          element={
            <ApresentacaoGate>
              <ArcaApresentacoesPage />
            </ApresentacaoGate>
          }
        />
        <Route
          path="apresentacao/modelos"
          element={
            <ApresentacaoGate>
              <ArcaModelosPage />
            </ApresentacaoGate>
          }
        />
        <Route
          path="apresentacao/configuracoes"
          element={
            <ApresentacaoGate>
              <ArcaConfiguracoesPage />
            </ApresentacaoGate>
          }
        />

        {/* Formulários */}
        <Route path="formularios" element={<ArcaFormulariosPage />} />
        <Route path="formularios/configuracao" element={<ArcaFormulariosConfigPage />} />

        {/* Editais */}
        <Route path="editais" element={<ArcaEditaisPage />} />

        {/* PDF tools */}
        <Route path="pdf" element={<ArcaPdfPage />} />
        <Route path="pdf/juntar" element={<ArcaPdfJuntarPage />} />
        <Route path="pdf/dividir" element={<ArcaPdfDividirPage />} />
        <Route path="pdf/organizar" element={<ArcaPdfOrganizarPage />} />
        <Route path="pdf/comprimir" element={<ArcaPdfComprimirPage />} />
        <Route path="pdf/jpg-para-pdf" element={<ArcaPdfJpgParaPdfPage />} />
        <Route path="pdf/word-para-pdf" element={<ArcaPdfWordParaPdfPage />} />
        <Route path="pdf/pdf-para-jpg" element={<ArcaPdfPdfParaJpgPage />} />
        <Route path="pdf/pdf-para-word" element={<ArcaPdfPdfParaWordPage />} />
        <Route
          path="pdf/processo-pagamento"
          element={
            <ProcessosContratosGate>
              <ArcaPdfProcessoPagamentoPage />
            </ProcessosContratosGate>
          }
        />
        <Route
          path="pdf/processo-administrativo"
          element={
            <ProcessosContratosGate>
              <ArcaProcessoAdministrativoListPage />
            </ProcessosContratosGate>
          }
        />
        <Route
          path="pdf/processo-administrativo/:id"
          element={
            <ProcessosContratosGate>
              <ArcaProcessoAdministrativoDetalhePage />
            </ProcessosContratosGate>
          }
        />

        {/* Compatibilidade com rotas antigas */}
        <Route path="apresentacoes" element={<Navigate to={ARCA_APRESENTACAO_HABILITADA ? '/arca/apresentacao/workspace' : ARCA_HOME} replace />} />
        <Route path="modelos" element={<Navigate to={ARCA_APRESENTACAO_HABILITADA ? '/arca/apresentacao/modelos' : ARCA_HOME} replace />} />
        <Route path="configuracoes" element={<Navigate to={ARCA_APRESENTACAO_HABILITADA ? '/arca/apresentacao/configuracoes' : ARCA_HOME} replace />} />
      </Route>
    </Routes>
  );
}
